<template>
  <div>
    <select id="device-type-selection" v-model="devicetype" @change="emitSelectedDevice">
      <option v-for="device in deviceTypes" :value="device.devicetype" :key="device.devicetype">{{ device.description }}</option>
    </select>

    <CIcon class="ml-4" :name="iconForSelectedDevice" :size="'3xl'" :title="devicetype"></CIcon>
  </div>
</template>

<script>
export default {
  name: 'DeviceSelect',
  props: {
    deviceTypes: {
      type: Array,
      default: () => [
        { devicetype: 'phone', description: 'Mobile Phone' },
        { devicetype: 'console', description: 'Games Console'},
        { devicetype: 'tablet', description: 'Tablet'},
        { devicetype: 'tv', description: 'Smart TV' },
        { devicetype: 'speaker', description: 'Internet connected speaker' },
        { devicetype: 'laptop', description: 'Laptop computer' },
        { devicetype: 'desktop', description: 'Desktop computer' },
        { devicetype: 'printer',  description: 'Internet connected printer' },
        { devicetype: 'watch',  description: 'Smart watch'},
        { devicetype: 'other', description: 'Other wifi device' }
       // ... add other devices here
      ]
    }
  },
  data() {
    return {
      devicetype: 'phone'
    };
  },
  computed: {
    iconForSelectedDevice() {
      switch (this.devicetype) {
        case 'phone':
          return 'cilMobile';
        case 'console':
          return 'cilGamepad';
        case 'tablet':
          return "cilTablet";
        case 'tv':
          return 'cilTv';
        case 'speaker':
          return "cilSpeaker";
        case 'laptop':
          return "cilLaptop";
        case 'desktop':
          return "cilMonitor";
        case 'printer':
          return "cilPrint";
        case 'watch':
          return "cilWatch";
        case 'other':
          return "cilWifi";
        default:
          return null;
      }
    }
  },
  methods: {
    emitSelectedDevice() {
      this.$emit('device-selected', this.devicetype);
    }

  }
}
</script>

<style scoped>
#device-type-selection {
  border-radius: 4px !important;
  width: 12rem;
}
</style>